{
  "name": "verizon-qos-viewer",
  "version": "1.0.16",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration local",
    "start:vps": "ng serve --configuration vps",
    "start:mauritius": "ng serve --configuration mauritius",
    "build": "ng build --configuration production",
    "build:local": "ng build --configuration local",
    "build:vps": "ng build --configuration vps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@10.9.2",
  "dependencies": {
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/platform-browser": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@deck.gl-community/editable-layers": "^9.2.5",
    "@deck.gl/core": "^9.2.11",
    "@deck.gl/layers": "^9.2.11",
    "@deck.gl/widgets": "^9.2.11",
    "@univerjs/preset-sheets-core": "^0.18.0",
    "@univerjs/preset-sheets-sort": "^0.18.0",
    "@univerjs/presets": "^0.18.0",
    "deck.gl": "^9.2.11",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
